import { Container, Row, Col, Badge, Dropdown } from "react-bootstrap";
import { showMoney } from "./Data/Money";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Button } from "./Controls/Button";
import { Plan } from "./Data/ApiTypes";

export function FacilityPlanListPage() {
  const nav = useNavigate();
  const plans = useLoaderData() as Plan[];

  return (
    <Container>
      <Row className="justify-content-start mb-3">
        <Col xs="auto">
          <Button className="w-100 btn-main" onClick={ () => nav( "create" ) }>
                Create New Monthly Plan
            </Button>
        </Col>
      </Row>

      <Row className="justify-content-left">
        <Col md="9"  xl="8">
          {plans.map((plan) => (
            <Button
              key={plan.planId}
              onClick={() => nav(`${plan.planId}`)}
              className="w-100 text-start border border-2 border-primary my-3 rounded-4 p-3"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: "0.5rem",
                whiteSpace: "normal",
                wordWrap: "break-word"
              }}
            >
              <div className="h5 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {plan.isPrivate && <Badge className="me-1">Private</Badge>}
              {plan.isOneTermPlan && <Badge>One Term</Badge>}
              {" " + plan.name}
              </div>
              <div className="fs-5 fw-bold text-end">
                {plan.planPrice && !plan.isPrivate
                  ? showMoney(plan.planPrice.price)
                  : "Not Listed"}
              </div>
              <div className="text-secondary" style={{ gridColumn: "1 / -1", whiteSpace: "normal" }}>{plan.accessHours}</div>
            </Button>
          ))}
        </Col>
      </Row>
    </Container>
  );
}
